import { render, staticRenderFns } from "./echart-pie.vue?vue&type=template&id=5132edf8&scoped=true&"
import script from "./echart-pie.vue?vue&type=script&lang=js&"
export * from "./echart-pie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5132edf8",
  null
  
)

export default component.exports